module.exports = __webpack_public_path__ + "img/wamda.fb668f18.png";